<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Center Pincodes</p>
          </div>
        </div>
        <router-link slot="right" :to="{ name: 'ListPincodes' }" class="button is-small v-btn theme--light elevation-1 v-size--default primary" color="primary" elevation="1">
          Back to list</router-link
        >
      </div>
    </section>
    <form @submit.prevent="onSubmit" enctype="multipart/form-data" name="SaveWowKitMapping">
      <card-component>
        <template>
          <div class="columns is-mobile">
            <div class="column ">
              <div class="content">
                <b> .csv file must contain<br /></b>
                <ul>
                  <li>franchiseeID</li>
                  <li>Pincode</li>
                  <li>Status</li>
                  <li>Location (Not required)</li>
                  <li>City (Not required)</li>
                  <li>State (Not required)</li>
                </ul>
              </div>
            </div>
            <div class="column ">
              <section class="text-is-centered">
                <b-field>
                  <b-upload v-model="dropFiles" @input="csvToJsonInput(dropFiles)" accept=".csv" multiple drag-drop title="Please do upload .csv file only">
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Drop your files here or click to upload</p>
                      </div>
                    </section>
                  </b-upload>
                </b-field>

                <div class="tags">
                  <span v-for="(file, index) in dropFiles" :key="index" class="tag is-primary">
                    {{ file.name }}
                    <button class="delete is-small" type="button" @click="deleteDropFile(index)"></button>
                  </span>
                </div>
              </section>
            </div>
            <div class="column has-text-centered">
              <!-- <a class="button is-link" href="https://intellitots.s3.ap-south-1.amazonaws.com/admissionLeads.csv" download>Download dummy file</a> -->
            </div>
          </div>
          <footer class="column has-text-centered">
            <button class="button is-success" type="submit">Save</button>
          </footer>
          <div class="columns is-mobile">
            <div class="column" v-if="isResponse" style="display:inline-block; margin-right:5%;">
              <b-button class="has-text-left " outlined type="is-success">Success: {{ count.success }} </b-button>&nbsp;
              <b-button class="button has-text-centered" outlined type="is-info">Update: {{ count.update }}</b-button
              >&nbsp;
              <b-button class="button has-text-right" outlined type="is-danger">Failure: {{ count.failure }}</b-button>
            </div>
          </div>
          <div class="columns is-mobile">
            <div class="column" v-if="jsonData.length > 0" style="overflow-x:scroll;">
              <table>
                <thead>
                  <th class="text-is-centered" v-for="head in Object.keys(jsonData[0])" :key="head">
                    {{ head }}
                  </th>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in jsonData" :key="index">
                    <td v-for="(data, head) in row" :key="head">
                      {{ data ? data.toString() : '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </card-component>
    </form>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import csvtojsonV2 from 'csvtojson'
// import moment from 'moment'

export default {
  name: 'uploadEnquiries',
  components: {
    CardComponent
  },

  data () {
    return {
      jsonData: [],
      kitTypeVar: '',
      dropFiles: [],
      WowkitTypes: [],
      classID: '',
      classes: [],
      total: 0,
      paginated: false,
      kit: {},
      perPage: 10,
      loadingComponent: null,
      constantKit: constants.KIT,
      fileinput: '',
      isResponse: false,
      count: {
        success: 0,
        failure: 0,
        update: 0
      },
      colorCode: []
    }
  },
  created: function () {
    this.onStart()
  },
  methods: {
    onStart: async function () {
      this.isResponse = false
    },
    readerFile: function (file, onLoadCallback) {
      var reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    csvToJsonInput: async function (files) {
      if (files.length > 1) {
        this.jsonData = []
        this.dropFiles = []
        return this.$buefy.dialog.alert({
          message: 'Please Select single CSV file!',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      this.jsonData = []
      this.loadingComponent = this.$buefy.loading.open()
      this.isResponse = false
      let self = this
      if (files.length > 1) {
        this.dropFiles.splice(0, 1)
      }
      let file = files[0]
      this.readerFile(file, async e => {
        self.jsonData = await csvtojsonV2().fromString(e.target.result)
      })
      this.loadingComponent.close()
    },
    deleteDropFile (index) {
      this.isResponse = false
      this.dropFiles.splice(index, 1)
      this.jsonData = []
    },
    async onSubmit (event) {
      this.loadingComponent = this.$buefy.loading.open()
      let that = this
      this.hasClicked = true
      this.loader = true
      try {
        if (!that.dropFiles.length) {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'Please upload file to save franchisee Pincodes!',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        let isError = false
        that.jsonData.forEach(obj => {
          if (!obj.franchiseeID || !obj.pincode || !obj.status) {
            isError = true
          }
        })

        if (isError) {
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            message: 'Invalid data-some required fields are empty ',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        this.count = {
          success: 0,
          failure: 0,
          update: 0
        }
        let length = that.jsonData.length
        let data = []
        let i = 0
        while (i < length) {
          let endIndex = length > i + 50 ? i + 50 : i + length - i

          let array = that.jsonData.slice(i, endIndex)
          i = i + 50
          let response = await http.post(`${constants.API_URL}/api/pincodes/bulk-create`, { data: array })
          if (response && response.data) {
            this.count = {
              success: this.count.success + response.data.count.success,
              failure: this.count.failure + response.data.count.failure,
              update: this.count.update + response.data.count.update
            }
            data.push(...response.data.response)
          }
        }
        this.loader = false
        this.loadingComponent.close()
        this.dropFiles.splice(0, 1)
        this.jsonData = data
        let message = `Uploading Status:-\r\n
        Succeed: ${this.count.success} \nFailed: ${this.count.failure} \nUpdated: ${this.count.update}`
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: message,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error while uploading  center pincode', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
<style scoped>
table,
th,
td {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
  padding: 0.65rem 0.7rem;
  font-size: 1rem;
}
table {
  overflow-x: scroll;
  overflow-y: scroll;
}
td {
  display: table-cell;
  padding: 5px;
  color: black;
}
th {
  width: 15px;
  color: #fff;
  background-color: #56509f;
}
.hidden {
  display: none;
}
.statusCode {
  font-style: italic;
  font-weight: 600;
}
</style>
